import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'
import { RouterLink } from '@angular/router'
import { AppSignals } from '@appShared/services/app.signals'
import { PageTitleComponent } from '@appShared/components/page-title/page-title.component'

/**
 * Download page for one of our side-loaded mobile apps (Advantage4dealers, SWcapture, ...).
 *
 *   <app-app-download title="SWcapture" icon="fa-camera" subtitle="..." description="..."
 *                     [iosDownloadUri]="..." [androidDownloadUri]="..."
 *                     [androidInstructionsUri]="..." [iosInstructionsUri]="...">
 *      <li>feature one</li>
 *      <li>feature two</li>
 *   </app-app-download>
 *
 * Projected <li> elements become the "What it does" list.
 * The button for the device we detect is shown as the primary action.
 */
@Component({
   selector: 'app-app-download',
   templateUrl: './app-download.component.html',
   styleUrls: ['./app-download.component.less'],
   imports: [RouterLink, PageTitleComponent],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppDownloadComponent {
   title = input.required<string>()
   icon = input<string>('fa-mobile-screen')
   subtitle = input<string | null>(null)
   description = input.required<string>()

   iosDownloadUri = input.required<string>()
   androidDownloadUri = input.required<string>()
   iosRequirement = input<string>('iOS 14.2 or later')
   androidRequirement = input<string>('Android 5 or later')

   androidInstructionsUri = input.required<string>()
   iosInstructionsUri = input.required<string>()
   supportUri = input.required<string>()

   private _appSignals = inject(AppSignals)
   platformIsAndroid = this._appSignals.platformIsAndroid
   platformIsIOS = this._appSignals.platformIsIOS

   /** Which download to lead with. Unknown platforms (desktop) show both as equals. */
   primary = computed<'ios' | 'android' | null>(() =>
      this.platformIsAndroid() ? 'android' : this.platformIsIOS() ? 'ios' : null
   )
}
